
export enum TOOLS {
	NAVIGATE_IN_FARM_SECTION = "navigate_in_farm_section",
	NAVIGATE_IN_GROWUNIT_SECTION = "navigate_in_growunit_section",
	NAVIGATE_IN_COMPONENT = "navigate_in_component",
	NAVIGATE_CROP_DETAILS = "navigate_crop_details",
	NAVIGATE_RECIPE_DETAILS = "navigate_recipe_details",

	SHOW_PIVOT_GRID = "show_pivot_grid",
	//SET_PIVOT_GRID_VISIBLE_PROPERTIES_VALUES = "set_pivot_grid_visible_properties_values",

	GET_CROPS_LIST = "get_crops_list",
	GET_CROP_DETAIL = "get_crop_detail",
	GET_RECIPES_LIST = "get_recipes_list",
	GET_RECIPE_DETAIL = "get_recipe_detail",

	GET_CYCLES_LIST = "get_cycles_list",
	GET_CYCLE_DETAIL = "get_cycle_detail",
}
